import api from 'services/api.service';

const teamsResource = '/teams';

export const getTeamById = (teamId) => api
  .get(`${teamsResource}/get-team-by-id`, { teamId });

export const getTeams = () => api
  .get(`${teamsResource}/get-teams`);

export const createTeam = (data) => api
  .post(`${teamsResource}/create-team`, data);

export const updateTeam = (data) => api
  .post(`${teamsResource}/update-team`, data);

export const removeTeam = (data) => api
  .delete(`${teamsResource}/remove-team`, data);
